<div>
  <div tiimeLargeProperty>Prospect :</div>
  <div class="name-property" tiimeIconProperty>
    <mat-icon svgIcon="icon-prospect"></mat-icon>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.fullName }}
    </span>
  </div>
  <div tiimeIconProperty>
    <mat-icon svgIcon="icon-phone"></mat-icon>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.phone | phone }}
    </span>
  </div>
  <div tiimeIconProperty>
    <mat-icon svgIcon="icon-mail"></mat-icon>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.email }}
    </span>
  </div>
  <app-address-property
    tiimeIconProperty
    [street]="prospect.mailingStreet"
    [postalCode]="prospect.mailingPostalCode"
    [city]="prospect.mailingCity"
  ></app-address-property>
</div>
<div>
  <div tiimeLargeProperty>Entreprise :</div>
  <div tiimeProperty>
    <span class="nowrap">Nom</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.companyName }}
    </span>
  </div>
  <div tiimeProperty>
    <span class="nowrap">Forme juridique</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.companyLegalForm }}
    </span>
  </div>
</div>
<div>
  <div tiimeLargeProperty>Affectation :</div>
  <div tiimeProperty>
    <span class="nowrap">Groupe</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.businessUnit?.name }}
    </span>
  </div>
  <div tiimeProperty>
    <span class="nowrap">Réf. commercial</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.salesRepresentativeUser?.fullName }}
    </span>
  </div>
  <div tiimeProperty>
    <span class="nowrap">Date RDV</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.appointmentDate | date: 'dd/MM/yyyy à HH:mm' }}
    </span>
  </div>
  <div tiimeProperty>
    <span class="nowrap">Canal</span>
    <span class="italic ellipsis" tiimeFallbackText>
      {{ prospect.acquisitionChannel | codeAndLabel: acquisitionChannels }}
    </span>
  </div>
  <div tiimeProperty>
    <span class="nowrap">Intérêt compte pro Tiime</span>
    @if (prospect.tiimeBusinessProAccountIntention) {
      <app-tiime-business-pro-account-intention-icon
        [tiimeBusinessProAccountIntention]="prospect.tiimeBusinessProAccountIntention"
      />
    } @else {
      <span class="italic ellipsis tiime-fallback-text">n.c.</span>
    }
  </div>
</div>
<app-company-permanent-note-properties
  title="Note interne prospect :"
  [permanentNote]="prospect.internalComment"
></app-company-permanent-note-properties>
